<template>
  <div id="root">
    <h1>{{ title }}</h1>
    <h3 v-if="error">
      {{ error }}
    </h3>
    <div id="loading" v-else-if="!iframeUrl">
      <h5>
        Loading...
      </h5>
    </div>
    <iframe
      v-else
      :src="iframeUrl"
      :title="title"
      class="metabase-dashboard"
      frameborder="0"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const MetabaseRepository = RepositoryFactory.get('metabase');
const METABASE_URL = 'https://focus.metabaseapp.com';

export default {
    data() {
        return {
            iframeUrl: '',
            error: '',
            title: 'Reporting'
        };
    },
    methods: {
        getDashboard() {
            MetabaseRepository.getSlbsToolToken()
                .then((response) => {
                    const { token } = response.data;
                    // The page shows its own title, so hide Metabase's
                    this.iframeUrl = `${METABASE_URL}/embed/dashboard/${token}#bordered=false&titled=false`;
                })
                .catch((error) => {
                    this.error = error.response && error.response.status === 403
                        ? 'You do not have permission to view this page.'
                        : 'An error occurred loading this report. Try reloading the page.';
                });
        },
    },
    created() {
        this.getDashboard();
    },
};
</script>

<style scoped>
.metabase-dashboard {
  width: 100%;
  height: calc(100vh - 180px);
  min-height: 600px;
}
</style>
